(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animix-related-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('animix-related-slider')) {
  customElements.define('animix-related-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.animix-related__grid');
      if (!this.track) return;
      this.controls = this.querySelector('.animix-related__controls');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interacting = false;
      this.inView = false;
      this.abort = new AbortController();
      const on = (target, event, handler) => target.addEventListener(event, handler, {signal:this.abort.signal});
      this.sync = () => {
        this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
      };
      this.move = direction => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        let next = position + direction * step;
        if (direction > 0 && position >= max - 2) next = 0;
        else if (direction < 0 && position <= 2) next = max;
        else next = Math.max(0, Math.min(max, next));
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollTo({left:rtl ? -next : next, behavior:this.motion.matches ? 'instant' : 'smooth'});
      };
      on(this.querySelector('[data-related-prev]'), 'click', () => this.move(-1));
      on(this.querySelector('[data-related-next]'), 'click', () => this.move(1));
      on(this.track, 'pointerdown', () => { this.interacting = true; });
      on(window, 'pointerup', () => { this.interacting = false; });
      on(window, 'pointercancel', () => { this.interacting = false; });
      this.visibilityObserver = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; });
      this.visibilityObserver.observe(this);
      this.resizeObserver = new ResizeObserver(this.sync);
      this.resizeObserver.observe(this.track);
      this.timer = setInterval(() => {
        if (!this.interacting && this.inView && !document.hidden && !this.querySelector(':focus-visible') && !this.controls.hidden) this.move(1);
      }, 3200);
      this.sync();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
